<div>
	<span>{{"frame.footer.copyright" | msgKey}}</span>
</div>
